import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchOrganizer, resetOrganizer, upsertOrganizer } from './actions';

import { Organizer } from '../../domain/interfaces/organizer';

type OrganizerSliceState = {
  isLoading: boolean;
  isLoaded: boolean;
  isTeamCreating: boolean;
  isTeamEditing: boolean;
  isSaving: boolean;
  info: Organizer | null;
};

type OrganizerReducerBuilder = ActionReducerMapBuilder<OrganizerSliceState>;

const initialState: OrganizerSliceState = {
  isLoading: false,
  isLoaded: false,
  isTeamCreating: false,
  isTeamEditing: false,
  isSaving: false,
  info: null,
};

function createFetchOrganizerReducer(builder: OrganizerReducerBuilder) {
  builder.addCase(fetchOrganizer.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(fetchOrganizer.fulfilled, (state, action) => {
    const info = action.payload;

    state.isLoading = false;
    state.isLoaded = true;
    state.info = info;
  });

  builder.addCase(fetchOrganizer.rejected, (state) => {
    state.isLoading = false;
    state.isLoaded = true;
  });
}

function createUpsertOrganizerReducer(builder: OrganizerReducerBuilder) {
  builder.addCase(upsertOrganizer.pending, (state) => {
    state.isSaving = true;
  });

  builder.addCase(upsertOrganizer.fulfilled, (state, action) => {
    state.isSaving = false;
    state.info = action.payload;
  });

  builder.addCase(upsertOrganizer.rejected, (state) => {
    state.isSaving = false;
  });
}

function createResetOrganizerReducer(builder: OrganizerReducerBuilder) {
  builder.addCase(resetOrganizer, (state) => {
    state.isLoaded = false;
    state.isLoading = false;
    state.info = null;
  });
}

const slice = createSlice({
  name: 'organizer',
  initialState,
  reducers: {
    removeChampionshipFromList: (state, action: PayloadAction<{ id: number }>) => {
      if (!state.info) return;
      state.info.latestTournaments = state.info.latestTournaments.filter((t) => t.id !== action.payload.id);
    },
  },
  extraReducers: (builder) => {
    createFetchOrganizerReducer(builder);
    createUpsertOrganizerReducer(builder);
    createResetOrganizerReducer(builder);
  },
});

export const { removeChampionshipFromList } = slice.actions;

const organizerReducer = slice.reducer;
export default organizerReducer;
